module.exports = __webpack_public_path__ + "static/media/metlife.31e3dadf.svg";